export default "__VITE_ASSET__iMtjcrNq__"